import React, { useContext, useEffect } from "react";
import FormControl from "../utils/formControl";
import { GlobalContex } from "../context/globalContext";

const PersonalInfo = () => {
  const {
    name,
    setName,
    email,
    setEmail,
    number,
    setNumber,
    validName,
    validEmail,
    validNumber,
    setValidName,
    setValidEmail,
    setValidNumber,
    submissionDate,
    setSubmissionDate
  } = useContext(GlobalContex);

  // Auto-set today's date on first render
  useEffect(() => {
    if (!submissionDate) {
      const today = new Date().toISOString().split("T")[0];
      setSubmissionDate(today);
    }
  }, [submissionDate, setSubmissionDate]);

  const setNameLogic = (e) => {
    setName(e.target.value);
    if (e.target.value.length >= 1) {
      setValidName(true);
    }
  };

  const setEmailLogic = (e) => {
    setEmail(e.target.value);
    if (e.target.value.length >= 1) {
      setValidEmail(true);
    }
  };

  const setNumberLogic = (e) => {
    setNumber(e.target.value);
    if (e.target.value.length >= 1) {
      setValidNumber(true);
    }
  };

  const handleDateChange = (e) => {
    setSubmissionDate(e.target.value);
  };

  return (
    <>
      <div>
        <h1 className="text-primary-marineBlue font-bold text-[1.6rem] md:text-3xl leading-9">
        TATTOO & PIERCING WAIVER
        </h1>
        <h3 className="text-gray-400 mt-2">
          Please provide your name, email address, and phone number.
        </h3>

        <div className="md:mt-7 mt-5 space-y-4">
          <FormControl
            label={"Name"}
            type={"text"}
            id={"name"}
            placeholder={"e.g. Stephen King"}
            onchange={setNameLogic}
            value={name}
            valid={validName ? true : false}
          />
          <FormControl
            label={"Email Address"}
            type={"email"}
            id={"email"}
            placeholder={"e.g. stephenking@lorem.com"}
            onchange={setEmailLogic}
            value={email}
            valid={validEmail ? true : false}
          />
          <FormControl
            label={"Phone Number"}
            type={"text"}
            id={"number"}
            placeholder={"e.g. +1 234 567 890"}
            onchange={setNumberLogic}
            value={number}
            valid={validNumber ? true : false}
          />
          <FormControl
            label={"Submission Date"}
            type={"date"}
            id={"submission-date"}
            onchange={handleDateChange}
            value={submissionDate}
            valid={true}
          />
        </div>
      </div>
    </>
  );
};

export default PersonalInfo;
